import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-toolbox/lib/button';
// import appStyle from '~/components/AppFrame/style.scss';
import { auth } from '~/actions/user';
import style from './style.scss';

class Login extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loginEmail: '',
      loginSecret: '',
      error: ''
    };
  }

  login() {
    auth(this.props.dispatch, this.context.apiClient, {
      username: this.state.loginEmail,
      password: this.state.loginSecret
    }).catch(err => {
      console.log(err);
      this.setState({ error: err.error ? err.error : JSON.stringify(err) });
    });
  }

  renderError() {
    if (this.state.error) {
      return <div className={style.error}>{this.state.error}</div>;
    }
    return false;
  }

  render() {
    return (
      <div className={style.loginArea}>
        <div className={style.logo} />
        <form
          onSubmit={e => {
            e.preventDefault();
            this.login();
          }}
        >
          {this.renderError()}
          <input
            type="text"
            required
            placeholder="Email address"
            value={this.state.loginEmail}
            onChange={e => this.setState({ loginEmail: e.target.value })}
          />
          <input
            placeholder="Secret"
            required
            type="password"
            value={this.state.loginSecret}
            onChange={e => this.setState({ loginSecret: e.target.value })}
          />
          <Button primary raised label="Log in" type="submit" />
        </form>
        <br />
        <br />
      </div>
    );
  }
}

export default connect()(Login);



// WEBPACK FOOTER //
// ./app/pages/Login/index.js